import React, { Fragment } from "react";

import { t } from "i18next";

import { Box } from "@mui/material";

import VehicleSelectCard from "@/src/components/molecules/VehicleSelectCard";
import { wizardTabSeparatorSx } from "@/src/components/molecules/VehicleSelectCard/vehicleSelectCardWizardView.styles";
import useVehicleSelectorNavigation from "@/src/components/organisms/VehicleSelectorGroup/useVehicleSelectorNavigation";
import {
  VEHICLE_TYPES,
  VEHICLE_TYPE_LABEL_KEYS
} from "@/src/components/organisms/VehicleSelectorGroup/vehicleSelector.constants";

import { VehicleType } from "@/src/types/types";

interface AuctionWizardVehicleSelectorProps {
  vehicleType: VehicleType;
}

const rootSx = {
  minWidth: { xs: "100%", sm: "180px", md: "200px" },
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  justifyContent: { xs: "stretch", sm: "center" },
  width: "100%",
  maxWidth: { sm: 600 },
  mx: { sm: "auto" }
};

const AuctionWizardVehicleSelector = (
  props: AuctionWizardVehicleSelectorProps
) => {
  const { vehicleType } = props;
  const handleVehicleSelection =
    useVehicleSelectorNavigation("auctionWizardView");

  return (
    <Box sx={rootSx}>
      {VEHICLE_TYPES.map((type, index) => (
        <Fragment key={type}>
          {index > 0 && <Box sx={wizardTabSeparatorSx} aria-hidden />}
          <VehicleSelectCard
            vehicleType={type}
            selectedVehicleType={vehicleType}
            onVehicleTypeChange={handleVehicleSelection}
            vehicleLabel={t(VEHICLE_TYPE_LABEL_KEYS[type])}
            displayMode="auctionWizardView"
          />
        </Fragment>
      ))}
    </Box>
  );
};

export default AuctionWizardVehicleSelector;
